import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lcon-tfire-snmp-ms16',
  templateUrl: './lcon-tfire-snmp-ms16.component.html',
  styleUrls: ['./lcon-tfire-snmp-ms16.component.css']
})
export class LconTfireSnmpMs16Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
